import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../orders.state';

export const getOrdersFeatureState = createFeatureSelector<State>('orders');
export const getReceiveDocuments = createSelector(getOrdersFeatureState, state => state.receiveDocument);
export const getReceiveDocumentsList = createSelector(getReceiveDocuments, state => state.payload);
export const getReceiveDocumentsLoading = createSelector(getReceiveDocuments, state => state.loading);
export const getReceiveDocumentsSuccess = createSelector(getReceiveDocuments, state => {
  return {
    ...state.payload, success: state.success
  };
});
export const getReceiveDocumentsError = createSelector(getReceiveDocuments, state => state.errorData);
